export const sensiIaSkillContract = {
  id: 'sensi_ia',
  version: '1.0.0',
  name: 'Sensi-IA',
  domain: 'fps_mobile',
  supportedGames: ['pubg_mobile', 'free_fire', 'codm', 'other'],
  gameAliases: {
    codm: ['cod', 'cod mobile', 'call of duty mobile', 'call of duty: mobile']
  },
  description: 'Diagnostica sintomas de mira e sugere ajustes de sensibilidade por relato, com video opcional e refinement por feedback.',
  intentExamples: [
    'minha mira sobe',
    'meu spray abre',
    'minha mira treme',
    'quero ajustar minha sensibilidade',
    'analisa minha sensi com esse video'
  ],
  modes: ['report_only', 'report_plus_video', 'feedback_refinement'],
  requiredSlotsByMode: {
    report_only: ['game', 'symptomReport'],
    report_plus_video: ['game', 'symptomReport', 'video'],
    feedback_refinement: ['sessionId', 'feedbackOutcome']
  },
  optionalSlots: [
    'weapon',
    'scope',
    'gyroMode',
    'currentSettings',
    'distance',
    'device',
    'fps',
    'fingers',
    'history',
    'language'
  ],
  slotSchemas: {
    game: {
      type: 'enum',
      values: ['pubg_mobile', 'free_fire', 'codm', 'other'],
      aliases: {
        codm: ['cod', 'cod mobile', 'call of duty mobile', 'call of duty: mobile']
      }
    },
    symptomReport: {
      type: 'object',
      description: 'Relato do usuario sobre o erro da mira.'
    },
    video: {
      type: 'file',
      acceptedKinds: ['video'],
      required: false
    },
    weapon: { type: 'string' },
    scope: { type: 'string' },
    gyroMode: { type: 'string' },
    currentSettings: { type: 'object' },
    distance: { type: 'string' },
    device: { type: 'string' },
    fps: { type: 'number' },
    fingers: { type: 'number' },
    sessionId: { type: 'string' },
    feedbackOutcome: {
      type: 'enum',
      values: ['improved', 'worse', 'same']
    },
    history: { type: 'array' },
    language: { type: 'string' }
  },
  askForMissingSlots: {
    game: 'Qual jogo voce quer ajustar?',
    symptomReport: 'O que esta acontecendo com a sua mira?',
    video: 'Se quiser uma analise com video, me envia a jogada. Se nao, eu sigo pelo seu relato.',
    sessionId: 'Preciso do diagnostico anterior para refinar com seguranca.',
    feedbackOutcome: 'Depois do teste, ficou melhor, pior ou igual?'
  },
  execution: {
    handler: 'SensiIaSkillAdapter',
    requiresBackend: true,
    backendRoute: '/api/sensi/diagnose',
    costClass: 'medium',
    requiresCredits: false,
    requiresPlan: 'free_limited_or_pro'
  },
  output: {
    mode: 'conversation',
    schema: 'sensitivity_diagnostic_result'
  },
  guardrails: {
    backendAccessSnapshotRequired: true,
    apiSensiAccessIsAuthoritative: true,
    apiSensiDiagnoseIsAuthoritative: true,
    noVideoValidationWithoutProcessedVideo: true,
    feedbackRefinementRequiresExistingSessionId: true,
    doNotExposeRawDiagnosticPayload: true,
    doNotUseLegacySensiUploadRoutes: true
  },
  capabilityMapping: {
    primaryCapabilityId: 'sensitivity_diagnostic',
    relatedCapabilityIds: []
  }
};

export default sensiIaSkillContract;
